import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/warehouse/overview")({
  component: () => (
    <Breadcrumb label="Overview" to="/warehouse/overview">
      <Outlet />
    </Breadcrumb>
  ),
});
